import React, { useState } from 'react';
import { Save, Bell, Lock, AlertTriangle } from 'lucide-react';
import AccountSettings from './AccountSettings';
import NotificationSettings from './NotificationSettings';
import ProfileDetails from './ProfileDetails';

const ProfileForm = () => {
  const [activeTab, setActiveTab] = useState<'profile' | 'notifications' | 'account'>('profile');

  const tabs = [
    { id: 'profile', label: 'Profile Details', icon: Save },
    { id: 'notifications', label: 'Notifications', icon: Bell },
    { id: 'account', label: 'Account Settings', icon: Lock }
  ] as const;

  return (
    <div>
      {/* Tabs */}
      <div className="flex border-b border-gray-800 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-4 py-2 -mb-px ${
              activeTab === tab.id
                ? 'text-brand border-b-2 border-brand'
                : 'text-content-secondary hover:text-content-primary'
            }`}
          >
            <tab.icon className="w-4 h-4" />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === 'profile' && <ProfileDetails />}
      {activeTab === 'notifications' && <NotificationSettings />}
      {activeTab === 'account' && <AccountSettings />}
    </div>
  );
};

export default ProfileForm;